/* eslint-disable @typescript-eslint/no-explicit-any */
export const langMap: any = {
  at: 'de',
  de: 'de',
  hu: 'hu',
  en: 'en-gb',
  teszt: 'teszt',
}
